import React from 'react';
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import routes from "./routes/routes";
import theme from "./theme/theme";
import Layout from "./layouts/Layout";
import ScrollToTop from './routes/ScrollToTop';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <ChakraProvider theme={theme}>
          {/* Default meta tags for all pages - can be overridden by individual pages */}
          <Helmet>
            <meta name="description" content="Business Automation Ltd - Leading provider of business automation solutions, software development, and digital transformation services." />
            <meta name="author" content="Business Automation Ltd" />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Business Automation Ltd" />
            <meta property="og:title" content="Business Automation Ltd" />
            <meta property="og:description" content="Leading provider of business automation solutions, software development, and digital transformation services." />
            <meta property="og:image" content="/png/BA.png" />
            <meta property="og:url" content="https://www.ba-systems.com" />
            
            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Business Automation Ltd" />
            <meta name="twitter:description" content="Leading provider of business automation solutions, software development, and digital transformation services." />
            <meta name="twitter:image" content="/png/BA.png" />
            
            {/* LinkedIn */}
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
          </Helmet>
          
          <Router>
             <ScrollToTop />
          <Routes>
          {routes.map((route, index) => {
            // Handle /admin route with children
            if (route.id === "admin") {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={route.element}
                >
                  {route.children &&
                    route.children.map((childRoute, childIndex) => (
                      <Route
                        key={`${index}-${childIndex}`}
                        path={childRoute.path}
                        element={childRoute.element}
                      >
                        {childRoute.children &&
                          childRoute.children.map((nestedRoute, nestedIndex) =>
                            nestedRoute.index ? (
                              <Route
                                key={`${index}-${childIndex}-${nestedIndex}`}
                                index
                                element={nestedRoute.element}
                              />
                            ) : (
                              <Route
                                key={`${index}-${childIndex}-${nestedIndex}`}
                                path={nestedRoute.path}
                                element={nestedRoute.element}
                              />
                            )
                          )}
                      </Route>
                    ))}
                </Route>
              );
            }

            // Special routes without Layout (visiting card)
            if (route.path === '/idCard/:email') {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={route.element}
                />
              );
            }

            // All other routes wrapped in the main Layout
            return (
              <Route
                key={index}
                path={route.path}
                element={<Layout>{route.element}</Layout>}
              />
            );
          })}
        </Routes>
      </Router>
    </ChakraProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
